import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingSampleManagement,
    getSampleManagementById,
    saveOrUpdateSampleManagement,
    deleteSampleManagement
} from 'app/services/SampleManagementService';

import { SampleManagement } from "app/common/Model/SampleManagement";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class SampleManagementStore {
    listAllSampleManagement = [];
    searchSampleManagement = new SearchObject();
    pageSampleManagement = null;
    selectedSampleManagement = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteSampleManagement = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingSampleManagement = () => {
        pagingSampleManagement(this.searchSampleManagement).then(({ data }) => {
            this.pageSampleManagement = data;
        })
    }

    handleChangeFormSearch = (searchSampleManagement) => {
        this.searchSampleManagement = checkSearchObject(this.searchSampleManagement, searchSampleManagement);
        this.pagingSampleManagement();
    }

    handleOpenFormCreateOrEdit = (sampleManagementId) => {
        if (Boolean(sampleManagementId)) {
            getSampleManagementById(sampleManagementId).then(({ data }) => {
                this.selectedSampleManagement = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedSampleManagement = new SampleManagement();
            this.openFormCreateOrEdit = true;
        }
    }

    saveSampleManagement = async (sampleManagement, { setSubmitting }) => {
        return await saveOrUpdateSampleManagement(sampleManagement).then(() => {
            this.selectedSampleManagement = null;
            toast.success("Lưu mẫu xét nghiệm thành công!");
            this.pagingSampleManagement();
            this.handleClosePopup();
            this.recentlyUpdated = true;
            this.listAllSampleManagement = [];
        }).catch(function (error) {
            toast.error("Lưu mẫu xét nghiệm thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteSampleManagement = (sampleManagement) => {
        this.selectedSampleManagement = { id: sampleManagement?.id };
        this.openConfirmDeleteSampleManagement = true;
    }

    handleConfirmDeleteSampleManagement = () => deleteSampleManagement(this.selectedSampleManagement?.id)
        .then(() => {
            if (this.searchSampleManagement?.pageIndex > 1 && this.pageSampleManagement?.content?.length === 1) {
                this.searchSampleManagement.pageIndex -= 1;
            }
            toast.success("Xóa mẫu xét nghiệm thành công!");
            this.pagingSampleManagement();
            this.recentlyUpdated = true;
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa mẫu xét nghiệm thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteSampleManagement = false;
    }

    resetStore = () => {
        this.searchSampleManagement = new SearchObject();
        this.pageSampleManagement = null;
        this.selectedSampleManagement = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteSampleManagement = false;
    }
}